// @ts-check
import React, { useRef } from "react"
import { TableHeadCell } from "./TableHeadCell.component"

/**
 * @param {import("./TableHead.component.types").TableHeadProps} props
 */
export const TableHead = (props) => {
  const { table } = props

  const openOverlayRef = useRef(null)

  return (
    <thead className="table__head">
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className="table__head-row">
          {headerGroup.headers.map((header) => (
            <TableHeadCell
              key={header.id}
              header={header}
              openOverlayRef={openOverlayRef}
            />
          ))}
        </tr>
      ))}
    </thead>
  )
}
